// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"index_pageTitle_1zbmt","cardTitle":"index_cardTitle_3fZGk","filledBtn":"index_filledBtn_1G2m3","requiredMark":"index_requiredMark_2ck8M","stripe0":"index_stripe0_zLGGf","stripe1":"index_stripe1_1Kg0o","stripe":"index_stripe_XIa3O","companyName":"index_companyName_1vfu0","basicInfoList":"index_basicInfoList_1QcVz","infoLabel":"index_infoLabel_1KqZn","infoValue":"index_infoValue_hKSet"};
    if(module.hot) {
      // 1788760848698
      var cssReload = require("/Applications/MAMP/htdocs/ai-contact/frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"","locals":true});
      module.hot.dispose(cssReload);
      
    }
  